// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"725":"f81aa14b","745":"f81aa14b","797":"f81aa14b","858":"f81aa14b"}[chunkId] + ".chunk.css";
};